export const getCleanedExternalId = (name: string, prefix?: string): string => {
    let cleanedId = name.toLowerCase()
        .replace(/\s+/g, '.')
        .replace(/[^a-z0-9.-]/g, '')
        .replace(/\.{2,}/g, '.');

    if (cleanedId.endsWith('.')) {
        cleanedId = cleanedId.slice(0, -1);
    }

    if (prefix && cleanedId && !cleanedId.startsWith(prefix)) {
        cleanedId = `${prefix}.${cleanedId}`;
    }

    return cleanedId;
};
